module.exports = __webpack_public_path__ + "static/media/creatingOrderBox.16bba302.svg";